<template>
    <SmartLinkItemComponent :id="model?.system?.id" :component="!model?.system?.workflow" v-if="model">
        <div class="basic-content-block" :id="`_${model?.system?.id}`" :index="index">
            <div class="container" :class="{ 'pt-0': paddingModifications['pt-0'], 'pb-0': paddingModifications['pb-0'] }" data-aos="fade-in">
                <div class="title" v-if="model.elements.title.value">
                    <SmartLinkStandaloneElement :codename="type.elements.title.codename">
                        <h1>{{ model.elements.title.value }}</h1>
                    </SmartLinkStandaloneElement>
                </div>
                <div class="content" v-if="!isEmpty(model?.elements?.content?.value)">
                    <SmartLinkStandaloneElement :codename="type.elements.content.codename">
                        <RichText :value="model.elements.content.value" />
                    </SmartLinkStandaloneElement>
                </div>
            </div>
        </div>
    </SmartLinkItemComponent>
</template>

<script lang="ts" setup>
import { contentTypes, type PlatformPageBasicContentBlockModel } from '~~/app/models';

const type = contentTypes.platform_page_basic_content_block;
const props = defineProps<{ model: PlatformPageBasicContentBlockModel }>();

const { addItem, getBlockIndex } = useAnchorNavBar();

const index = computed(() => getBlockIndex(props.model.system.codename));
addItem(props.model.elements.show_in_anchor_bar,
    props.model.elements.title.value,
    `${props.model?.system?.id}`,
    props.model.system.codename);

const paddingModifications = computed(() =>
    getPaddingModifications(props.model.elements.padding_modifications__padding_modifications)
)
</script>